import SuccessToast from '../../../views/components/misc/SuccessToast'
import ErrorToast from '../../../views/components/misc/ErrorToast'
import {toast, Slide} from 'react-toastify'
import WarningToast from '../../../views/components/misc/WarninigToast'

const showSuccessToast = (msg) => {
  return toast.success(<SuccessToast msg={msg} dataTestId="submit-alert" />, {
    icon: false,
    transition: Slide,
    hideProgressBar: true,
    autoClose: 5000,
  })
}

const showErrorToast = (msg) => {
  return toast.error(<ErrorToast msg={msg} dataTestId="submit-alert" />, {
    icon: false,
    transition: Slide,
    hideProgressBar: true,
    autoClose: 5000,
  })
}
const showWarningToast = (msg) => {
  return toast.warning(<WarningToast msg={msg} dataTestId="submit-alert" />, {
    icon: false,
    transition: Slide,
    hideProgressBar: true,
    autoClose: 5000,
  })
}

export {showSuccessToast, showErrorToast, showWarningToast}
